import { useEffect } from "react"
import ProductCard from "@/components/woocommerce/ProductCard"
import { pushDataLayer } from "@/lib/helpers/tagManager"
import { getProductResponse } from "@/lib/helpers/tagManager"
import BlockHeader from "@/common/partials/block-header/block-header"
import Block from "@/components/wrappers/block"
import styles from "./related-products.module.css"

const RelatedProducts = ({ block }) => {
  const { products } = block.attrs

  useEffect(() => {
    if (!products) {
      return
    }
    pushDataLayer(
      {
        event: "view_item_list",
        ecommerce: { items: getProductResponse(products) }
      },
      true
    )
  }, [products])

  if (!products || products.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      gap={block.attrs.blockGap ?? "normal"}
      className={styles.wrapper}>
      <BlockHeader
        heading={block?.attrs?.heading}
        align={block?.attrs?.align}
      />
      <div className="products">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </Block>
  )
}

export default RelatedProducts
